import axios from "axios";
import store from "../store";

class Client {
	async put(
		tables,
		profile = null,
		style = null,
		client_var = null,
		env = null,
		database = null,
		viewver = null,
		tags = null,
		actions_help = null,
		document_extraction = null, 
		document_extraction_type = null
	) {
		let jwt = store.state.jwt;

		var obj = {};

		if (tables) obj.tables = tables;

		if (profile) obj.profile = profile;

		if (style) obj.style = style;

		if (client_var) obj.var = client_var;

		if (env) obj.env = env;

		if (database) obj.database = database;

		if (viewver) obj.viewver = viewver;
		
		if (tags) obj.tags = tags;

		if (actions_help) obj.actions_help = actions_help

		if (document_extraction) obj.document_extraction = document_extraction
		
		if (document_extraction_type) obj.document_extraction_type = document_extraction_type

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/put", obj, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async put_admin(client)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/put_admin", {client}, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getClientUsers() {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/users", {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.users);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getClientGroups() {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/groupes", {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.groups);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getClients() {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/all", {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.clients);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async addCredit(client_uid, credit)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/credit", {client_uid, credit}, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async creditHistory()
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/clients/credit/history", {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.history);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Client();
